// extracted by mini-css-extract-plugin
module.exports = {"inputField":"inputField_inputField__1jcWa","inputMessage":"inputField_inputMessage__VK7Wd"};